import { Popup } from 'react-vant'
import { prefix } from '.';
import DeliveryProcess from './DeliveryProcess';
import { useEffect, useMemo, useState } from 'react';
import { IDeliveryAddress, IDiningMethods, IPickUpOption } from '@/types/common-types';
import TakeawayProcess from './TakeawayProcess';
import DineInIcon from '../svg/DineInIcon';
import TakeawayIcon from '../svg/TakeawayIcon';
import DeliveryIcon from '../svg/DeliveryIcon';
import DineInProcess from './DineInProcess';
import { TFunction } from "i18next";
import i18n from '@/i18n';

interface IDiningMethodsProps {
  t: TFunction<"common", undefined>;
  visible: boolean;
  type: IDiningMethods | undefined;
  types: IDiningMethods[];
  addressList: IDeliveryAddress[];
  businessID: string;
  pickUpOption?: IPickUpOption; 
  setType: (type: IDiningMethods) => void;
  setAddressList: (record: IDeliveryAddress[]) => void;
  onClose: () => void;
  onConfirm: (option?: any) => void;
  handleChangeAddress: (index: number) => void;
}

const DiningMethods: React.FC<IDiningMethodsProps> = (props) => {
  const {
    t,
    visible,
    type,
    types,
    addressList,
    businessID,
    pickUpOption,
    setType,
    onConfirm,
    onClose,
    setAddressList,
    handleChangeAddress,
  } = props;

  const lang = i18n.language;

  const [title, setTitle] = useState<string>('');
  const [showForm, setShowForm] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [showTabs, setShowTabs] = useState<boolean>(true);
  const [showPickTime, setShowPickTime] = useState<boolean>(false);
  const [selectKey, setSelectIndex] = useState<string>('1');

  useEffect(() => {
    resetTitle();
    if (pickUpOption && pickUpOption.delivery_date !== 'Immediately') {
      setSelectIndex('2');
    }
    // eslint-disable-next-line
  }, [type, lang, visible]);

  const handleClose = () => {
    onClose();
    resetState();
  };

  const handleConfirm = (option?: any) => {
    onConfirm(option);
    resetState();
  };

  const resetTitle = () => {
    let title = '';
    if (type === IDiningMethods.DINE_IN) {
      title = t('dineInTitle');
    } else {
      if (type === IDiningMethods.TAKEAWAY) {
        title = t('takeawayTitle');
      } else {
        title = t('deliveryTitle');
      }
    };
    setTitle(title);
  }

  const resetState = () => {
    setTimeout(() => {
      setShowForm(false);
      setShowSearch(false);
      setIsUpdate(false);
      setShowTabs(true);
      setShowPickTime(false);
      setSelectIndex('1');
      resetTitle();
    }, 500);
  };

  const chooseItems = useMemo(() => {

    let nodes = types.map(item => {
      let node = null;
      switch (item) {
        case IDiningMethods.DINE_IN:
          node = (
            <>
              <DineInIcon size={25} />
              <div className={`${prefix}-choose-item-title`}>{t('dineIn')}</div>
            </>
          )
          break;
        case IDiningMethods.TAKEAWAY:
          node = (
            <>
              <TakeawayIcon />
              <div className={`${prefix}-choose-item-title`}>{t('takeaway')}</div>
            </>
          )
          break;
        case IDiningMethods.DELIVERY:
          node = (
            <>
              <DeliveryIcon />
              <div className={`${prefix}-choose-item-title`}>{t('delivery')}</div>
            </>
          )
          break;
  
        default:
          break;
      }
  
      return (
        <div key={item} onClick={() => setType(item)} className={`${prefix}-choose-item ${type === item ? 'active' : ''}`}>
          {node}
        </div>
      );
    })
    return nodes;
    // eslint-disable-next-line
  }, [types, type, lang]);

  return (
    <Popup
      visible={visible}
      closeable
      round
      position='bottom'
      style={{ height: '90%' }}
      onClose={handleClose}
    >
      <div className={`${prefix}`}>
        <div className={`${prefix}-title`}>{title}</div>
        {
          types.length > 1 && showTabs &&
          <div className={`${prefix}-choose`}>
            {chooseItems}
          </div>
        }
        <div className={`${prefix}-content`}>
          {
            type === IDiningMethods.DELIVERY &&
            <DeliveryProcess
              t={t}
              addressList={addressList}
              showForm={showForm}
              showSearch={showSearch}
              isUpdate={isUpdate}
              setShowTabs={setShowTabs}
              setTitle={setTitle}
              setIsUpdate={setIsUpdate}
              setShowForm={setShowForm}
              setShowSearch={setShowSearch}
              onConfirm={handleConfirm}
              setAddressList={setAddressList}
              handleChangeAddress={handleChangeAddress}
            />
          }
          {
            type === IDiningMethods.TAKEAWAY &&
            <TakeawayProcess
              t={t}
              visible={visible}
              selectKey={selectKey}
              showPickTime={showPickTime}
              pickUpOption={pickUpOption}
              setShowPickTime={setShowPickTime}
              setSelectIndex={setSelectIndex}
              setShowTabs={setShowTabs}
              setTitle={setTitle}
              onConfirm={handleConfirm}
            />
          }
          {
            type === IDiningMethods.DINE_IN &&
            <DineInProcess
              t={t}
              visible={visible}
              businessID={businessID}
              onConfirm={handleConfirm}
            />
          }
        </div>
      </div>
    </Popup>
  )
};

export default DiningMethods;